import { Box, Grid, MenuItem, TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";

import pages from "../../constants/pages";
import List from "./audience list components/List";
import { useAxios, useComponent } from "../../hooks";
import { CreateButton } from "../css components/Button";
import { PageHeader, Pagination } from "../../components";
import { getAllAudiences } from "./create audience components/audienceObjects";

export default function AudienceList() {
  const axios = useAxios();
  const navigate = useNavigate();
  const { loader } = useComponent();

  const options = [5, 10, 25, 50, 100];
  const [loading, setLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [audiences, setAudiences] = useState([]);

  const [page, setPage] = useState({
    page: 1,
    totalCount: 0,
    lastCount: 0,
    itemsPerPage: 10,
  });

  const { activeBrand } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    setLoading(true);

    axios({
      url:
        "/brand/getAllAudiences?brandId=" +
        activeBrand.ID +
        `&page=${page.page}&limit=${page.itemsPerPage}` +
        (searchKey ? `&search=${encodeURIComponent(searchKey)}` : ""),
    }).then((response) => {
      if (response.status) {
        if (response.data.audienceData.length > 0) {
          setPage((prev) => ({
            ...prev,
            totalCount: response.data.totalCounts,
            lastPage: response.data.campaignData?.length < 10,
          }));

          setAudiences(getAllAudiences(response));
        } else {
          setAudiences([]);
        }
      }
      setLoading(false);
    });
  }, [axios, activeBrand.ID, loader, page.page, searchKey, page.itemsPerPage]);

  function handlePagination(step, index) {
    setPage((prev) => ({
      ...prev,
      page: step === "index" ? index : prev + (step === "next" ? 1 : -1),
    }));
  }

  const handleChange = (event) => {
    setPage((prev) => ({
      ...prev,
      itemsPerPage: event.target.value,
    }));
  };

  return (
    <Fragment>
      <PageHeader
        pageName={"Existing Audience Cohorts"}
        pageHeader="View and manage your existing audience cohorts."
        buttons={[
          <CreateButton
            variant="contained"
            onClick={() => navigate(pages.createAudience.route)}
          >
            Create New Audience Cohort
          </CreateButton>,
        ]}
      />

      <List
        audiences={audiences}
        loading={loading}
        setPage={setPage}
        setSearchKey={setSearchKey}
        component=""
      />

      {!!page.totalCount && (
        <Grid item container display={"flex"} justifyContent={"space-between"}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography variant="body1" fontWeight={600}>
              Items per page:
            </Typography>
            <TextField
              select
              size="small"
              value={page.itemsPerPage}
              onChange={handleChange}
              sx={{
                width: 80,
                "& .MuiOutlinedInput-input": {
                  textAlign: "center",
                },
              }}
            >
              {options.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          <Pagination
            count={Math.ceil(page.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page.page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
